import { render, staticRenderFns } from "./transactionCompactDateRenderer.vue?vue&type=template&id=51803c52"
import script from "./transactionCompactDateRenderer.vue?vue&type=script&lang=js"
export * from "./transactionCompactDateRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports